import { Check, XCircle } from "lucide-react";
import { ORDER_STATUS, STATUS_FLOW } from "@/lib/format";

export const StatusTimeline = ({ status }) => {
  if (status === "batal") {
    return (
      <div className="flex items-center gap-3 rounded-2xl border border-rose-500/30 bg-rose-500/10 p-5 text-rose-200" data-testid="order-status-cancelled">
        <XCircle className="h-5 w-5" /> Pesanan ini dibatalkan.
      </div>
    );
  }
  const current = STATUS_FLOW.indexOf(status);
  return (
    <ol className="grid grid-cols-4 gap-2" data-testid="order-status-timeline">
      {STATUS_FLOW.map((key, i) => {
        const done = i <= current;
        return (
          <li key={key} className="space-y-3">
            <div className={`h-1 rounded-full ${done ? "bg-gold" : "bg-white/10"}`} />
            <div className="flex items-center gap-2">
              <span className={`flex h-5 w-5 items-center justify-center rounded-full border text-[10px] ${done ? "border-gold bg-gold text-black" : "border-white/20 text-neutral-500"}`}>
                {done ? <Check className="h-3 w-3" /> : i + 1}
              </span>
              <span className={`text-xs ${done ? "text-white" : "text-neutral-500"}`}>{ORDER_STATUS[key].label}</span>
            </div>
          </li>
        );
      })}
    </ol>
  );
};
